module.exports = __webpack_public_path__ + "img/no-image.26aa7ec5.svg";